// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"4856953c","977":"e628838f"}[chunkId] + ".chunk.js";
};